import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Autoplay, Pagination, Controller,
} from 'swiper/modules';
import ruby from '../assets/images/skills/ruby.svg';
import rails from '../assets/images/skills/rails.svg';
import javascript from '../assets/images/skills/javascript.svg';
import nodejs from '../assets/images/skills/nodejs.svg';
import express from '../assets/images/skills/express.svg';
import react from '../assets/images/skills/react.svg';
import redux from '../assets/images/skills/redux.svg';
import html5 from '../assets/images/skills/html5.svg';
import css3 from '../assets/images/skills/css3.svg';
import sass from '../assets/images/skills/sass.svg';
import tailwindcss from '../assets/images/skills/tailwindcss.svg';
import bootstrap from '../assets/images/skills/bootstrap.svg';
import rspec from '../assets/images/skills/rspec.svg';
import jest from '../assets/images/skills/jest.svg';
import postgresql from '../assets/images/skills/postgresql.svg';
import mysql from '../assets/images/skills/mysql.svg';
import mongodb from '../assets/images/skills/mongodb.svg';
import git from '../assets/images/skills/git.svg';
import github from '../assets/images/skills/github.svg';
import heroku from '../assets/images/skills/heroku.svg';
import netlify from '../assets/images/skills/netlify.svg';
import render from '../assets/images/skills/render.svg';
import npm from '../assets/images/skills/npm.svg';
import yarn from '../assets/images/skills/yarn.svg';

import 'swiper/css/pagination';
import '../assets/style/customSwiperTwo.scss';

const Skills = () => {
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const sectionRef = useRef(null);

  const [controlledSwiperMain, setControlledSwiperMain] = useState(null);
  const [slidesPerView, setSlidesPerView] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      // Define your rules for `slidesPerView` based on width
      if (width < 468) {
        setSlidesPerView(1);
      } else if (width >= 468 && width < 632) {
        setSlidesPerView(2);
      } else {
        setSlidesPerView(3);
      }
    };

    // Call the function to set the initial state based on current window size
    handleResize();

    // Set up the event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (controlledSwiperMain) {
          if (!controlledSwiperMain.running) {
            controlledSwiperMain.autoplay.start();
          }
          controlledSwiperMain.autoplay[entry.isIntersecting ? 'resume' : 'stop']();
        }
      },
      { threshold: 0.5 },
    );

    observer.observe(sectionRef.current);
    const sectionRefCurrent = sectionRef.current;

    return () => {
      observer.unobserve(sectionRefCurrent);
    };
  }, [controlledSwiperMain]);

  return (
    <div ref={sectionRef} className="my-skills-wrapper">
      <div style={{ zIndex: 999 }}>
        <h1>
          <span className="circle-button">
            <span className="button-text">Skills</span>
            <span className="button-circle">
              <svg className="aesthetic" height="100" width="100">
                <circle cx="50" cy="50" r="40" />
              </svg>
            </span>
          </span>
        </h1>
      </div>
      <Swiper
        onSwiper={setControlledSwiperMain}
        wrapperClass="mySwiperTwo-wrapper"
        slidesPerView={slidesPerView}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        pagination={{
          clickable: true,
          el: '.swiper-pagination2', // Use a unique class name for pagination in this component
          dynamicBullets: true,
          dynamicMainBullets: 6,
        }}
        modules={[Autoplay, Pagination, Controller]}
        className="mySwiperTwo"
      >
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Ruby" className="skills-span-img">
            <img src={ruby} alt="Ruby" />
            Ruby
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Rails" className="skills-span-img">
            <img src={rails} alt="Rails" />
            Rails
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="JavaScript" className="skills-span-img">
            <img src={javascript} alt="JavsScript" />
            JavaScript
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Node.js" className="skills-span-img">
            <img src={nodejs} alt="Node.js" />
            Node.js
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Express.js" className="skills-span-img">
            <img src={express} alt="Express.js" />
            Express.js
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="React" className="skills-span-img">
            <img src={react} alt="React" />
            React
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Redux" className="skills-span-img">
            <img src={redux} alt="Redux" />
            Redux
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="HTML5" className="skills-span-img">
            <img src={html5} alt="HTML5" />
            HTML5
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="CSS3" className="skills-span-img">
            <img src={css3} alt="CSS3" />
            CSS3
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Sass" className="skills-span-img">
            <img src={sass} alt="Sass" />
            Sass
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Tailwind CSS" className="skills-span-img">
            <img src={tailwindcss} alt="Tailwind CSS" />
            Tailwind CSS
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Bootstrap" className="skills-span-img">
            <img src={bootstrap} alt="Bootstrap" />
            Bootstrap
          </span>
        </SwiperSlide>
        <SwiperSlide title="Hotwire (Rails)" className="mySwiperTwo-slide">
          <span className="skills-span-img">
            <svg width="135px" height="135px" viewBox="0 0 289.69 79.8" xmlns="http://www.w3.org/2000/svg">
              <path className="letter" d="m31.3 18.73-2.98 17.14h-9.24l2.99-17.14h-13.79l-8.28 47.53h13.79l3.25-18.71h9.24l-3.26 18.71h13.82l8.28-47.53z" />
              <path className="letter" d="m82.83 20.14a8.76 8.76 0 0 0 -3.77-1.57 28.88 28.88 0 0 0 -5.18-.42h-11.47a30.88 30.88 0 0 0 -5.28.42 12.38 12.38 0 0 0 -4.3 1.57 9.37 9.37 0 0 0 -3.11 3.12 14.72 14.72 0 0 0 -1.81 5.14l-4.86 27.78a13.63 13.63 0 0 0 0 5.29 5.9 5.9 0 0 0 1.9 3.26 8.21 8.21 0 0 0 3.7 1.65 27.81 27.81 0 0 0 5.32.46h11.42a30.28 30.28 0 0 0 5.47-.46 12.18 12.18 0 0 0 4.31-1.65 9.64 9.64 0 0 0 3.11-3.26 15.27 15.27 0 0 0 1.78-5.29l4.86-27.78a11.25 11.25 0 0 0 0-5.14 6 6 0 0 0 -2.09-3.12zm-16.35 34.47h-9.37l4.28-24.24h9.37z" />
              <path className="letter" d="m88.01 30.78h10.72l-6.17 35.48h13.78l6.18-35.48h10.73l2.1-12.05h-35.24z" />
              <path className="letter" d="m171.06 18.73-9.28 26.11-.03-26.11h-10.9l-9.03 26.04-.17-26.04h-13.85l2.61 47.53h12.36l9.27-24.92.71 24.92h11.96l19.21-47.53z" />
              <path className="letter" d="m248.66 20.88a8.41 8.41 0 0 0 -3.72-1.68 25.41 25.41 0 0 0 -5.2-.47h-22.81l-8.29 47.53h13.79l2.82-16.26h1.9l5.26 16.26h15.11l-6.89-18.26h.37a16.35 16.35 0 0 0 2.88-1.21 8.38 8.38 0 0 0 2.36-1.85 10.24 10.24 0 0 0 1.7-2.68 16.21 16.21 0 0 0 1.07-3.56l1.59-9.24a12.89 12.89 0 0 0 0-5.28 6.18 6.18 0 0 0 -1.94-3.3zm-12.14 11.33-.88 5.16a5.62 5.62 0 0 1 -.34.93 2.14 2.14 0 0 1 -.56.7 2.76 2.76 0 0 1 -.82.42 3.28 3.28 0 0 1 -1 .15h-5.81l1.63-9.57h5.81a2.84 2.84 0 0 1 1 .15 1.64 1.64 0 0 1 .65.43 1.39 1.39 0 0 1 .32.68 2.79 2.79 0 0 1 0 .95z" />
              <path className="letter" d="m287.75 29.83 1.94-11.1h-29.95l-8.28 47.53h30.49l1.93-11.1h-16.7l1.39-7.95h12.77l1.8-10.25h-12.77l1.22-7.13z" />
              <path fill="yellow" className="bolt" d="m211.75 23-11.57 2.69 10.09-25.69-30.2 38.92 14.41-2.84-13.59 26.54 7.86-1.77-7.95 18.95 24.97-26.97-9.21 2.13z" />
            </svg>
            Hotwire (Rails)
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="RSpec" className="skills-span-img">
            <img src={rspec} alt="RSpec" />
            RSpec
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Jest" className="skills-span-img">
            <img src={jest} alt="Jest" />
            Jest
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="PostgreSQL" className="skills-span-img">
            <img src={postgresql} alt="PostgreSQL" />
            PostgreSQL
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="MySQL" className="skills-span-img">
            <img src={mysql} alt="MySQL" />
            MySQL
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="MongoDB" className="skills-span-img">
            <img src={mongodb} alt="MongoDB" />
            MongoDB
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Git" className="skills-span-img">
            <img src={git} alt="Git" />
            Git
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="GitHub" className="skills-span-img">
            <img src={github} alt="GitHub" />
            GitHub
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Heroku" className="skills-span-img">
            <img src={heroku} alt="Heroku" />
            Heroku
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Netlify" className="skills-span-img">
            <img className="skills-img" src={netlify} alt="Netlify" />
            Netlify
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Render" className="skills-span-img">
            <img className="skills-img" src={render} alt="Render" />
            Render
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="NPM" className="skills-span-img">
            <img className="skills-img" src={npm} alt="NPM" />
            npm
          </span>
        </SwiperSlide>
        <SwiperSlide className="mySwiperTwo-slide">
          <span title="Yarn" className="skills-span-img">
            <img className="skills-img" src={yarn} alt="Yarn" />
            Yarn
          </span>
        </SwiperSlide>

        <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20" />
          </svg>
          <span ref={progressContent} />
        </div>

      </Swiper>
      <div className="swiper-pagination2" />
    </div>
  );
};

export default Skills;
